<div class="dialog-container">
    <div class="dialog-title">
        <h2>{{data?.title}}</h2>
    </div>
    
    <div class="dialog-content">
        <mat-form-field appearance="outline" class="full-width mb-16" *ngIf="data?.plot?.category === 'Gateway'">
            <mat-label>Module</mat-label>
            <mat-select [formControl]="selectedModule" (selectionChange)="onModuleChange($event.value)">
                <mat-option *ngFor="let mod of availableModules" [value]="mod.value">{{ mod.name }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Configuration</mat-label>
            <textarea matInput rows="10" [formControl]="desiredValues"></textarea>
        </mat-form-field>
    </div>
    
    <div class="button-container">
        <button mat-button (click)="closeDialog()">Close</button>
        <button mat-raised-button color="primary" (click)="data?.plot?.category === 'Gateway' ? onUpdate() : updateAttributes()" [disabled]="data?.plot?.category === 'Gateway' ? (selectedModule.invalid || desiredValues.invalid) : (desiredValues.invalid)">Update</button>
    </div>
</div>